import { Ability } from '@casl/ability'

// Actions and Subjects as string unions (optional but helpful)
export type Actions = string
export type Subjects = string

export type AppAbility = Ability<[Actions, Subjects]>

// Shared ability instance
export const ability = new Ability<[Actions, Subjects]>([])
